export default __webpack_public_path__ + "static/yellow-91b6913f42f28a411941ad949be4019e.gif";